import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppShell,
  CardPanel,
  PanelTitleRow,
  PrimaryButton,
  TopbarActionGroup,
} from "../components";
import { clearClientSession } from "../config/auth";

const QrPage = () => {
  const [qrCode, setQrCode] = useState(null);
  const [manualCode, setManualCode] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const storedQR = localStorage.getItem("generatedQRCode");
    const storedManualCode = localStorage.getItem("generatedManualCode");

    if (storedQR) {
      setQrCode(storedQR);
    }

    if (storedManualCode) {
      setManualCode(storedManualCode);
    }
  }, []);


  const handleDownload = () => {
    if (!qrCode) {
      return;
    }

    const link = document.createElement("a");
    link.href = qrCode;
    link.download = "qr-code.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleLogout = () => {
    clearClientSession();
    navigate("/");
  };

  return (
    <AppShell
      mainClassName="ui-shell__main--admin"
      contentClassName="ui-qr-content"
      topbarActions={
        <TopbarActionGroup
          showDashboard
          onDashboard={() => navigate("/HomePage")}
          onLogout={handleLogout}
        />
      }
    >
      <CardPanel className="ui-card-panel--wide ui-qr-admin-panel">
        <PanelTitleRow title="Generate QR Code" />

        <div className="ui-qr-panel">
          {qrCode ? (
            <img src={qrCode} alt="Generated QR" className="ui-qr-image" />
          ) : (
            <p className="ui-helper-text">Loading QR Code...</p>
          )}

          {manualCode ? (
            <div className="ui-manual-code-box">
              <p className="ui-helper-text">Unable to scan?</p>
              <h2>{manualCode}</h2>
              <p className="ui-helper-text">
                Text this code to the church attendance number to receive the
                attendance link.
              </p>
            </div>
          ) : null}

          <PrimaryButton
            className="ui-qr-download"
            onClick={handleDownload}
            disabled={!qrCode}
            size="lg"
          >
            Download Image
          </PrimaryButton>
        </div>
      </CardPanel>
    </AppShell>
  );
};

export default QrPage;
